import { render, staticRenderFns } from "./ModalUpdateOrCreateAssignedArea.vue?vue&type=template&id=fefb1956"
import script from "./ModalUpdateOrCreateAssignedArea.vue?vue&type=script&lang=js"
export * from "./ModalUpdateOrCreateAssignedArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports